// TODO: Handle server errors. Now user can't proceed if server responded with
// error

import React, { useState, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

import { Lang } from '../../../../types/common-types'
import { State } from '../../../../state-actions-reducers'
import AccountForm from '../../../../types/account-form.types'
import TextInput from '../../../../shared/Inputs/TextInput/TextInput'
import AddButton from '../../../..//shared/Buttons/AddButton'
import DeleteButton from '../../../..//shared/Buttons/DeleteButton'
import InformationImage from '../../../../images/informationIcon.svg'
import { getBanks, getBanksKz } from '../../../../hooks/useBanksCustomHook'
import {
  validateAddress,
  validateName,
  stringDigitsLength,
  smartValidateString,
} from '../../../../validate/validators'
import styles from '../../FiscalScreenTwo.module.scss'
import { useFormStore } from '../../../../store/formStore'
import InfoMessage from '../../../../shared/InfoMessage/InfoMessage'

interface Props {
  lang: Lang
  accountForm: AccountForm
}

/* THE COMPONENT */
function CompanyScreenTwoRus({
  lang,
  accountForm,
}: Props) {
  const { watch, setValue } = useFormContext<State>()
  const { strictValidation } = useFormStore()
  const { errors } = useFormContext<State>().formState
  const state = watch()

  // Local bank field validation — reliable across re-renders
  function bankErr(i: number, field: string): boolean {
    if (!strictValidation) return false
    const bank = (state.BankDetails[i] || {}) as any
    switch (field) {
      case 'F_BankBIK':  return !(bank.F_BankBIK?.replace(/_/gim, '')?.length >= 8)
      case 'F_BankRS':   return !(bank.F_BankRS?.replace(/_/gim, '')?.length >= 12)
      case 'F_BankName': return !smartValidateString(bank.F_BankName || '')
      case 'F_BankKS':   return !(bank.F_BankKS?.replace(/_/gim, '')?.length >= 12)
      default: return false
    }
  }
  const [header, ...listItems] =
    state.F_FiscalType === '1'
      ? accountForm.uploadF_DocTextIP[lang].split('%li%')
      : accountForm.uploadF_DocText[lang].split('%li%')

  const [focus, setFocus] = useState('')

  async function autoFill(bik: string, i: number) {
    let response = await getBanks(bik),
      name = response.suggestions?.[0]?.value,
      ks = response.suggestions?.[0]?.data.correspondent_account
    name &&
      ks &&
      setValue('BankDetails', state.BankDetails.map((item, key) => {
        return key === i ?
          { ...item, F_BankName: name, F_BankBIK: bik, F_BankKS: ks }
          : { ...item }
      }), { shouldDirty: true })
  }

  const [banksCount, setbanksCount] = useState(state.BankDetails.length || 1)
  const banks = () => {
    let banksList = []
    for (let i = 0; i < banksCount; i++) {
      {
        banksList.push(
          <div className={styles.banksRow} key={i}>
            <div className="row">
              <div className="col-2 col-xs-12">
                {/* F_BankBIK */}
                <TextInput
                  disabled={!state.agreed}
                  lang={lang}
                  content={accountForm.F_BankBIK}
                  onChange={F_BankBIK => {
                    setValue('BankDetails', state.BankDetails.map((item, key) => {
                      return key === i
                        ? { ...item, F_BankBIK: F_BankBIK }
                        : { ...item }
                    }), { shouldDirty: true })
                    if (F_BankBIK.replace(/_/gim, '').length >= 8) {
                      autoFill(F_BankBIK.replace(/_/gim, ''), i)
                    }
                  }}
                  // onChange={F_BankBIK =>
                  //   dispatch({ type: actions.F_BankBIK, data: F_BankBIK })
                  // }
                  value={
                    state.BankDetails[i] ? state.BankDetails[i]?.F_BankBIK : ''
                  }
                  valid={!bankErr(i, 'F_BankBIK')}
                  mask="999999999"
                  required
                />
              </div>
              <div className="col-6 col-xs-12">
                {/* F_BankName */}
                <TextInput
                  disabled={!state.agreed}
                  lang={lang}
                  content={accountForm.F_BankName}
                  onChange={F_BankName => {
                    setValue('BankDetails', state.BankDetails.map((item, key) => {
                      return key === i
                        ? { ...item, F_BankName: F_BankName }
                        : { ...item }
                    }), { shouldDirty: true })
                  }}
                  value={
                    state.BankDetails[i] ? state.BankDetails[i].F_BankName : ''
                  }
                  valid={
                    state.BankDetails[i].F_BankName.length > 0
                      ? smartValidateString(state.BankDetails[i].F_BankName) &&
                        !bankErr(i, 'F_BankName')
                      : !bankErr(i, 'F_BankName')
                  }
                  onBlur={() => setFocus('')}
                  focus={focus === 'F_BankName' || undefined}
                />
                {/* <a
                  onClick={() => {
                    if (state.BankDetails[i].F_BankBIK)
                      autoFill(state.BankDetails[i].F_BankBIK, i, 'name')
                  }}
                  className={styles.autoFill}
                >
                  {accountForm.autoFill[lang]}
                </a> */}
                {/* <img
                  src={InformationImage}
                  className={styles.informationImage}
                  alt="i"
                />
                <div className={styles.informationBox}>
                  {accountForm.Bank_AutoFill[lang]}
                </div> */}
              </div>
            </div>
            <div className="row">
              <div className="col-3 col-xs-12">
                {/* F_BankRS */}
                <TextInput
                  disabled={!state.agreed}
                  lang={lang}
                  content={accountForm.F_BankRS}
                  onChange={F_BankRS => {
                    setValue('BankDetails', state.BankDetails.map((item, key) => {
                      return key === i
                        ? { ...item, F_BankRS: F_BankRS }
                        : { ...item }
                    }), { shouldDirty: true })
                  }}
                  // onChange={F_BankRS =>
                  //   dispatch({ type: actions.F_BankRS, data: F_BankRS })
                  // }
                  value={
                    state.BankDetails[i] ? state.BankDetails[i].F_BankRS : ''
                  }
                  valid={!bankErr(i, 'F_BankRS')}
                  mask="99999999999999999999"
                  required
                />
              </div>
              <div className="col-4 col-xs-12">
                {/* F_BankKS */}
                <TextInput
                  disabled={!state.agreed}
                  lang={lang}
                  content={accountForm.F_BankKS}
                  onChange={F_BankKS => {
                    setValue('BankDetails', state.BankDetails.map((item, key) => {
                      return key === i
                        ? { ...item, F_BankKS: F_BankKS }
                        : { ...item }
                    }), { shouldDirty: true })
                  }}
                  // onChange={F_BankKS =>
                  //   dispatch({ type: actions.F_BankKS, data: F_BankKS })
                  // }
                  value={
                    state.BankDetails[i] ? state.BankDetails[i].F_BankKS : ''
                  }
                  valid={!bankErr(i, 'F_BankKS')}
                  onBlur={() => setFocus('')}
                  focus={focus === 'F_BankKS' || undefined}
                  mask="99999999999999999999"
                />
                {/* <a
                  onClick={() => {
                    if (state.BankDetails[i].F_BankBIK)
                      autoFill(state.BankDetails[i].F_BankBIK, i, 'ks')
                  }}
                  className={styles.autoFill}
                >
                  {accountForm.autoFill[lang]}
                </a>
                <img
                  src={InformationImage}
                  className={styles.informationImage}
                  alt="i"
                />
                <div className={styles.informationBox}>
                  {accountForm.Bank_AutoFill[lang]}
                </div> */}
              </div>
            </div>
            {i > 0 ? (
              <>
                <DeleteButton
                  className={styles.banksDeleteButton}
                  onClick={() => {
                    setValue('BankDetails', state.BankDetails.filter(
                        (item, index) => index !== i
                      ), { shouldDirty: true })
                    setValue('BankDetails', state.BankDetails.filter(
                        (item, index) => index !== i
                      ), { shouldDirty: true })
                    setbanksCount(banksCount - 1)
                  }}
                />
                <button
                  className={styles.banksMobileDeleteButton}
                  onClick={() => {
                    setValue('BankDetails', state.BankDetails.filter(
                        (item, index) => index !== i
                      ), { shouldDirty: true })
                    setValue('BankDetails', state.BankDetails.filter(
                        (item, index) => index !== i
                      ), { shouldDirty: true })
                    setbanksCount(banksCount - 1)
                  }}
                >
                  Удалить
                </button>
              </>
            ) : null}
          </div>
        )
      }
    }
    return banksList
  }
  const [banksList, setbanksList] = useState(banks)
  useEffect(() => {
    setbanksList(banks)
  }, [banksCount, state.BankDetails, strictValidation])

  return (
    <>
      <main className={styles.main}>
        <div className="form-group">
          <div className="row">
            <div className="col-12 col-xs-12">
              <h3>{accountForm.Fiscal_Bank_Requisites[lang]}</h3>
              {state.BankDetails.find((bank)=> bank?.F_BankBIK?.replace(/_/gim, '')?.length < 9) && <InfoMessage type={"default"} text={<>
                <span>{accountForm.bankDetailsAutoFill[lang]}</span>
              </>} />}
            </div>
          </div>
          {banksList}
          <div className="row">
            <div className="col-4 col-xs-12">
              <div
                className={styles.addButtonBox}
                onClick={() => {
                  setbanksCount(banksCount + 1)
                  setValue('BankDetails', state.BankDetails.concat({
                      F_BankBIK: '',
                      F_BankName: '',
                      F_BankRS: '',
                      F_BankKS: '',
                  }), { shouldDirty: true })
                }}
              >
                <AddButton />
                <span>{accountForm.addBanksButton[lang]}</span>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="form-group">
          <div className="row">
            <div className="col-6 col-xs-12"> */}
        {/* F_TaxType */}
        {/* <SelectInput
                lang={lang}
                noOptionsMessage={accountForm.noOptionsMessage}
                content={accountForm.F_TaxType}
                onChange={data =>
                  setValue('F_TaxType', data, { shouldDirty: true })
                }
                value={state.F_TaxType}
                options={accountForm.F_TaxTypeValues}
                valid={
                  !errors.F_TaxType &&
                  validateName(state.F_TaxType)
                }
                required
              /> */}
        {/* </div>
          </div>
        </div> */}
      </main>
    </>
  )
}

export default CompanyScreenTwoRus
